var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M119.1,155.9h-9.2v-4c0-4.5-3.4-7.9-7.8-7.9H88.9c-4.4,0-8.3,3.4-8.3,7.9v4h-8.7c-4.6,0-8.6,3.6-8.6,8.2 v27.1c0,4.6,4,8.7,8.6,8.7H119c4.6,0,8.2-4,8.2-8.7v-27.1C127.2,159.5,123.7,155.9,119.1,155.9z M104.3,155.9H86.2v-4 c0-1.4,1.4-2.3,2.8-2.3h13c1.4,0,2.3,0.9,2.3,2.3V155.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M133.2,125.9c-0.1,0.9,0.2,1.8,0.8,2.5c0.6,0.7,1.5,1,2.4,1h1.1v60.9c0,5.2,4.2,9.4,9.4,9.4 c5.2,0,9.4-4.2,9.4-9.4v-60.9h4.4v60.9c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4v-60.9h1.1c0.9,0,1.8-0.3,2.5-1 c0.6-0.7,0.9-1.6,0.8-2.5l-1.2-19.6c6.9-1.3,11.5-7.8,10.5-14.7L188.1,56c-1.1-7.9-7.9-13.9-15.9-13.9h-27.7 c-8.1,0-14.9,6-15.9,14l-5.4,40.7H15.7c-5.2,0-9.4,4.2-9.4,9.4s4.2,9.4,9.4,9.4h118.5L133.2,125.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8EAF0",
    cx: 158.6,
    cy: 17.2,
    r: 17.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M44.1,53.9c-8.1,0-15,6-16,14.1l-2.8,22.9h66.2l-3-23c-1-8-7.9-14-16-14H44.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8EAF0",
    cx: 58.4,
    cy: 30.5,
    r: 17.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.9abe69bf1bf2eff1d90b395962090f78.svg";
export { ForwardRef as ReactComponent };